/* eslint-disable max-len */
import React from 'react';

const NewShevronDown: React.FC = (): React.JSX.Element => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fillRule="evenodd" clipRule="evenodd" d="M2.19526 5.2519C2.45561 4.99155 2.87772 4.99155 3.13807 5.2519L8 10.1138L12.8619 5.2519C13.1223 4.99155 13.5444 4.99155 13.8047 5.2519C14.0651 5.51225 14.0651 5.93436 13.8047 6.19471L8 11.9994L2.19526 6.19471C1.93491 5.93436 1.93491 5.51225 2.19526 5.2519Z" fill="#2C305E"/>
		</svg>
	);
};

export default NewShevronDown;